import { Box, IconButton, Skeleton } from "@chakra-ui/react";
import { useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAPI } from "../api/useAPI";
import { useAPIQuery } from "../api/useAPIQuery";
import { useToastOnAPIError } from "../api/useToastOnAPIError";
import { LOGGED_IN_HOME_PAGE } from "../config";
import { NotesList } from "../note/NotesList";
import { AppPage } from "../utils/AppPage";
import { Card } from "../utils/Card";
import { THEME_COLOR_SCHEME } from "../utils/theme";
import { isParamNumeric } from "../utils/utils";
import { YouthKidCard } from "./YouthKidCard";
import { MdModeEdit } from "react-icons/md";
import { YouthKidDeleteButton } from "./YouthKidDeleteButton";

export const YouthKidPage = () => {
  const { youthKidId } = useParams();
  const api = useAPI();
  const {
    data: youthKidGetData,
    state: youthKidGetState,
    error: youthKidGetError,
    query: youthKidGetQuery,
  } = useAPIQuery({ apiCall: api.youthKidGet });
  useToastOnAPIError({
    error: youthKidGetError,
    title: `Unable to get youth kid ${youthKidId}`,
  });

  const youthKid = useMemo(
    () => youthKidGetData?.youthKids[0],
    [youthKidGetData?.youthKids]
  );

  const navigate = useNavigate();

  // Get youth kid
  useEffect(() => {
    if (isParamNumeric(youthKidId)) {
      youthKidGetQuery({ id: Number(youthKidId) });
    }
  }, [youthKidGetQuery, youthKidId]);

  // Navigate if invalid
  useEffect(() => {
    if (!isParamNumeric(youthKidId)) {
      navigate(LOGGED_IN_HOME_PAGE);
    }
  }, [navigate, youthKidId]);

  return (
    <AppPage title={youthKid ? `${youthKid.fName} ${youthKid.lName}` : ""}>
      {youthKidGetState === "success" && youthKid ? (
        <YouthKidCard youthKid={youthKid} />
      ) : (
        <Skeleton />
      )}
      {youthKid ? (
        <>
          <Card
            marginBottom={4}
            padding={4}
            display={"flex"}
            alignItems={"center"}
          >
            <Box fontSize={"large"} fontWeight={"bold"} width={"100%"}>
              {youthKid.fName + " " + youthKid.lName}'s Activity
            </Box>
            <Box display={"flex"} width={"100%"} justifyContent={"flex-end"}>
              <IconButton
                marginLeft={2}
                colorScheme={THEME_COLOR_SCHEME}
                icon={<MdModeEdit />}
                aria-label={"edit"}
                variant={"outline"}
                onClick={() => navigate(`/youth-kid/${youthKid.id}/edit`)}
              />
              <YouthKidDeleteButton
                youthKid={youthKid}
                marginLeft={2}
                aria-label={"Delete Kid"}
              />
            </Box>
          </Card>
          <NotesList queryParams={{ youthKidId: youthKid.id }} />
        </>
      ) : null}
    </AppPage>
  );
};
